module.exports = __webpack_public_path__ + "img/s00167.70040845.png";